import { useCallback } from 'react';
import {
  McAvatar,
  McButton,
  McList,
  McListItem,
  McMenu,
  McThemeSwitch,
  McTopBar,
} from '@maersk-global/mds-react-wrapper';
import { useUserSessionContext } from '../hooks/contexts/useUserSessionContext';
import { useThemeContext } from '../hooks/contexts/useThemeContext';

interface AppTopBarProps {
  onToggleSidebar: () => void;
}

export const AppTopBar = ({ onToggleSidebar }: AppTopBarProps) => {
  const { userSession, logout } = useUserSessionContext();
  const { themeVariant, toggleThemeVariant } = useThemeContext();

  const handleLogout = useCallback(() => {
    logout();
  }, [logout]);

  const userInitials = userSession?.name
    ? userSession.name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((n) => n[0].toUpperCase())
        .join('')
    : 'U';

  return (
    <div className="app-topbar-wrapper">
      <McTopBar product="Engineering Management" productshort="EM">
        <McButton
          slot="link"
          icon="bars-horizontal"
          variant="plain"
          appearance="neutral"
          fit="small"
          hiddenlabel
          onClick={onToggleSidebar}
        >
          Menu
        </McButton>
        <div slot="actions" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <McThemeSwitch
            theme={themeVariant}
            change={toggleThemeVariant as unknown as (e: Event) => void}
          />
          <McMenu position="bottom-center">
            <McAvatar
              appearance="color-3"
              initials={userInitials}
              slot="trigger"
              style={{ cursor: 'pointer' }}
            />
            <McList>
              <McListItem label="Logout" onClick={handleLogout} />
            </McList>
          </McMenu>
        </div>
      </McTopBar>
    </div>
  );
};
